module.exports = __webpack_public_path__ + "static/media/Ananya.80effd4e.jpeg";